import React from 'react';
import { AudioPreview } from '../components/AudioPreview';
import { Hero } from '../components/Hero';
import { LeadSection } from '../components/LeadSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { FormatSection } from '../components/FormatSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { PDSection } from '../components/PDSection';
import { Footer } from '../components/Footer';
import { SalesPopup } from '../components/SalesPopup';
export function LandingPage() {
  return <main className="bg-dark-900 min-h-screen text-cream-100 selection:bg-gold-500/30 selection:text-gold-200" data-id="element-380">
      <Hero data-id="element-381" />
      <LeadSection data-id="element-382" />
      <WhatYouGet data-id="element-383" />
      <FormatSection data-id="element-384" />
      <PricingSection data-id="element-385" />
      <FAQSection data-id="element-386" />
      <PDSection data-id="element-387" />
      <Footer data-id="element-388" />
      <SalesPopup data-id="element-389" />
    </main>;
}